import * as React from 'react';
import classNames from 'classnames';

import FormHelperText from '../FormHelperText';
import IntlTelInput, { IntlTelInputProps } from 'react-intl-tel-input';

export interface PhoneInputProps extends IntlTelInputProps {
  name: string;
  className?: string;
  containerClassName?: string;
  wrapperClassName?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  helperText?: string | React.ReactNode;
  errorText?: string;
  hasError?: boolean;
  size?: 'large';
  placeholder?: string;
  // pass from register from react-hook-form
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  (props, ref) => {
    const {
      name,
      size,
      className,
      containerClassName,
      disabled,
      helperText,
      errorText,
      hasError = false,
      wrapperClassName,
      separateDialCode,
      fieldId,
      preferredCountries = ['us'],
      ...otherProps
    } = props;
    const helperTextId = `${name}-helper-text`;
    const inputClasses = classNames(className, 'ui-input', {
      'ui-input--disabled': disabled,
      'ui-input--error': hasError,
      [`ui-input--${size}`]: size,
    });
    const containerClasses = classNames(
      containerClassName,
      'ui-tel-input-container allow-dropdown intl-tel-input',
      {
        'ui-tel-input-dial': !!separateDialCode,
      }
    );
    const hasHelperText = helperText || hasError;

    return (
      <div className={wrapperClassName}>
        <IntlTelInput
          // @ts-expect-error
          ref={ref}
          fieldId={fieldId || name}
          fieldName={name}
          preferredCountries={preferredCountries}
          inputClassName={inputClasses}
          containerClassName={containerClasses}
          disabled={disabled}
          separateDialCode={separateDialCode}
          {...otherProps}
        />
        {hasHelperText && (
          <FormHelperText
            hasError={hasError}
            helperTextId={helperTextId}
            text={hasError ? errorText : helperText}
          />
        )}
      </div>
    );
  }
);

export default PhoneInput;
